import * as React from "react"
import {
    ChakraProvider,
} from "@chakra-ui/react";
import {ProjectList} from "./pages/ProjectList";
import {Workspace} from "./pages/Workspace";
import {Routes, Route} from 'react-router-dom';
import LoginPage from "./pages/Login";
import RangeComponent from "./components/Workspace/ResultsTab/RangeComponent";
import WorldMap from "./components/Home/Map";
import HomePage from "./pages/Home/HomePage";

export const App = () => (

    <ChakraProvider>
        <Routes>
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/"  element={<ProjectList/>} />
            <Route path="/workspace/:projectId" element={<Workspace/>} />
            <Route path="/chart" element={<RangeComponent maxDayRange={4} onRangeSave={()=>{}}/> }/>
            <Route path="/home" element={<HomePage/>}/>
            <Route path="/map" element={<WorldMap/>}/>
        </Routes>
    </ChakraProvider>
);